import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../services/supabase';
import './TransactionHistory.css';

export default function TransactionHistory({ onSelect }) {
  const { user } = useAuth();
  const [transactions, setTransactions] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const fetch = async () => {
      const { data } = await supabase
        .from('transactions')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false });
      setTransactions(data || []);
    };
    fetch();
  }, [user.id]);

  const filtered = filter === 'all' ? transactions : transactions.filter(t => t.type === filter);
  const isCash = (t) => t.type === 'deposit' || t.type === 'withdraw';

  return (
    <div className="transaction-history">
      <div className="txn-filters">
        {['all', 'buy', 'sell', 'deposit', 'withdraw'].map(f => (
          <button key={f} className={filter === f ? 'active' : ''} onClick={() => setFilter(f)}>
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>
      {filtered.length === 0 ? (
        <div className="txn-empty">No transactions yet</div>
      ) : (
        <div className="txn-list">
          {filtered.map(t => (
            <div
              key={t.id}
              className={`txn-item ${isCash(t) ? 'txn-cash' : ''}`}
              onClick={() => { if (!isCash(t)) onSelect({ ticker: t.ticker, name: t.ticker }); }}
            >
              <div className="txn-left">
                <span className={`txn-type ${t.type}`}>{t.type.toUpperCase()}</span>
                <div className="txn-info">
                  <span className="txn-ticker">{isCash(t) ? 'Cash' : t.ticker}</span>
                  <span className="txn-date">
                    {new Date(t.created_at).toLocaleDateString('en-US', {
                      month: 'short', day: 'numeric', year: 'numeric',
                      hour: '2-digit', minute: '2-digit',
                    })}
                  </span>
                </div>
              </div>
              <div className="txn-right">
                <span className={`txn-amount ${t.type === 'deposit' ? 'positive' : t.type === 'withdraw' ? 'negative' : ''}`}>
                  {t.type === 'deposit' ? '+' : t.type === 'withdraw' ? '-' : ''}${isCash(t) ? t.price.toFixed(2) : (t.shares * t.price).toFixed(2)}
                </span>
                {!isCash(t) && <span className="txn-detail">{t.shares} @ ${t.price.toFixed(2)}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
